import { withStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import Button from "@mui/material/Button";

export const LoginButton = withStyles((theme: Theme) => ({
  root: {
    borderRadius: 0,
  },
}))(Button);
